'use client'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Box, Grid, Typography } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { accordionTitleConstants, subAccordionConstants } from './GetTrayComponentsForThreeDBuilder';
import EachDesignCard from './EachDesignCard';
import EachProductCard from './EachProductCard';
import BuilderSelect from '@/store/builderStoreSelector';
import { useDispatch } from 'react-redux';
import { RoomModel, actions as builderActions } from "@/store/builderSlice";
import { loadDesignStyles } from "@/store/builder/thunks/builderDesignsLoader";
import axiosObj from '@/store/axios';
import LoadingSpinner from './LoadingSpinner';
import NoItemsMessage from './NoItemsMessage';
import axios from 'axios'
import { gtmClickTracking } from '@/utils';
interface MoreItemsProps {
    handleMoreItemsClosed: (isCloseMenu: boolean) => void;
    activeAccordion: any;
    items: any;
    handleSelectedDesignDetailId: (itemId: string) => void;
    handleMenuCloseDesignDetail: (isCloseMenu: boolean) => void;
    handleActiveAccordion: any;
    handleCloseProductDetails: (isCloseMenu: boolean) => void;
    handleSelectedProductDetailId: (itemId: string) => void;
}
export const designRoomTypeMap: { [key: string]: string } = {
    'Bedroom': 'bedroom',
    'Bed Room': 'bedroom',
    'Living Room': 'livingroom',
    'Dining Room': 'diningroom',
    'Home Office': 'homeoffice'
}
export const apiStatusConstants = {
    initial: 'INITIAL',
    pending: 'PENDING',
    fulfilled: 'FULFILLED',
    rejected: 'REJECTED'
}
const MoreItems: React.FC<MoreItemsProps> = (props) => {
    console.log('MoreItems component start-------------------')
    //props
    const { handleMoreItemsClosed, activeAccordion, items, handleSelectedDesignDetailId, handleMenuCloseDesignDetail, handleActiveAccordion, handleCloseProductDetails, handleSelectedProductDetailId } = props
    //utils
    const dispatch = useDispatch()
    //store
    //inorder to get the room type we need currentRoomId roomModels currentRoomModel
    const currentRoomId: string = BuilderSelect.activeSelection().roomId;
    const roomModels: RoomModel[] = BuilderSelect.roomModels().models;
    const currentRoomModel = roomModels.find(roomModel => roomModel.roomId === currentRoomId);
    //roomtype, currentDesignId, currentStyle are required for getting the current applied design to the room
    const roomType: string = currentRoomModel ? (designRoomTypeMap[currentRoomModel.roomType] || currentRoomModel.roomType.toLowerCase()) : '';
    const currentDesignId: string = BuilderSelect.ui().designId;
    const currentStyle: string = BuilderSelect.ui().styleName;
    const roomTypes = BuilderSelect.roomTypes();
    const styles = BuilderSelect.designContent().designStyles;
    //state
    const [isVisibleRooms, setIsVisibleRooms] = useState(false);
    const [selectedRoomType, setSelectedRoomType] = useState(roomType);
    const [isVisibleStyles, setIsVisibleStyles] = useState(false);
    const [selectedStyleType, setSelectedStyleType] = useState(currentStyle)
    const [apiStatus, setApiStatus] = useState<string>(() => {
        if (activeAccordion.childAccordion === subAccordionConstants.designs || activeAccordion.childAccordion === subAccordionConstants.products) {
            return apiStatusConstants.initial
        }
        return apiStatusConstants.fulfilled
    })
    const [data, setData] = useState<any>(items || [])
    const [isVisibleSearch, setIsVisibleSearch] = useState(false);
    //search
    const [query, setQuery] = useState('');
    const [searchQuery, setSearchQuery] = useState('')
    const [searchInput, setSearchInput] = useState('')
    const [searchSuggestions, setSearchSuggestions] = useState<any>([])
    const [showSearchQueryResults, setShowSearchQueryResults] = useState(true)
    const resultsContainerRef = useRef<any>(null)
    //initially it will be in more designs or products mode, once user types query and clicks on enter or clicks search term it will be switch to search mode
    const [searchMode, setSearchMode] = useState<boolean>(false)
    //validations
    const currentSelectedRoomDisplayName = roomTypes.find((eachRoom: any) => eachRoom.roomType === selectedRoomType)?.roomTypeDisplayName || 'All';
    const currentSelectedStyleDisplayName = styles.find((eachStyle: any) => eachStyle.style === selectedStyleType)?.styleDisplayName || "All";
    const showFilters: boolean = (activeAccordion.childAccordion === subAccordionConstants.designs || activeAccordion.childAccordion === subAccordionConstants.products)
    const productsMode = activeAccordion.parentAccordion === accordionTitleConstants.products
    //effects
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setSearchQuery(query)
        }, 400)
        return () => {
            clearTimeout(timeoutId)
        }
    }, [query])
    useEffect(() => {
        //for search suggestions
        async function fetchData() {
            try {
                const response = await axios.get(
                    `https://d221a61rb87vel.cloudfront.net/v1/api/search?searchInput=${searchQuery}&autoComplete=true`
                )
                if (response.status == 200) {
                    setSearchSuggestions(response.data?.searchSuggestions)
                } else {
                    throw new Error('error at search bar')
                }
            } catch (error) {
                console.log(error, 'error at search bar')
            }
        }
        if (searchQuery.length > 0) {
            fetchData()
        }
    }, [searchQuery])
    useEffect(() => {
        // to detect the click outside of the search results container
        const handleClickOutside = (event: any) => {
            if (resultsContainerRef.current && !resultsContainerRef.current.contains(event.target)) {
                setShowSearchQueryResults(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [])
    const fetchSearchResult = useCallback(async () => {
        setApiStatus(apiStatusConstants.pending)
        let url = `/api/search?searchInput=${searchInput}`
        if (selectedStyleType) {
            url = url + `&filters=style:${selectedStyleType}`
        }
        if (selectedRoomType) {
            url = url + `&roomType=${selectedRoomType}`
        }
        try {
            const response = await axiosObj.get(url)
            if (response.status === 200) {
                setData(response.data.products.filter((eachProduct: any) => eachProduct.model3dUrl))
                dispatch(builderActions.addProductData({ products: response.data.products.filter((eachProduct: any) => eachProduct.model3dUrl) }))
                setApiStatus(apiStatusConstants.fulfilled)
            } else {
                throw new Error('error at search bar')
            }
        } catch (error) {
            console.log(error)
            setApiStatus(apiStatusConstants.rejected)
        }
    }, [searchInput, selectedStyleType, selectedRoomType])
    useEffect(() => {
        if (searchMode) {
            fetchSearchResult()
        }
    }, [searchMode, fetchSearchResult])
    useEffect(() => {
        //to get styles based on room type
        if ((activeAccordion.childAccordion === subAccordionConstants.designs || activeAccordion.childAccordion === subAccordionConstants.products)) {
            dispatch(loadDesignStyles({ roomName: selectedRoomType }) as any);
        }
    }, [selectedRoomType, activeAccordion.childAccordion]);
    useEffect(() => {
        //effect to fetch the data
        async function fetchData() {
            setApiStatus(apiStatusConstants.pending)
            const makeApiCall = async (url: string) => {
                try {
                    const response = await axios.get(url);
                    if (response.status === 200) {
                        return response.data
                    } else {
                        throw new Error('error at moreitems component while fetching data')
                    }
                } catch (error) {
                    console.log(error, 'error at moreitems component while fetching data')
                    setApiStatus(apiStatusConstants.rejected)
                    return
                }
            }
            //actual condition start
            if (activeAccordion.childAccordion === subAccordionConstants.designs) {
                let url = 'https://nestingale.com/v2/api/designs?has3DSupport=true'
                if (selectedRoomType) url += `&roomType=${selectedRoomType}`
                if (selectedStyleType) url += `&style=${selectedStyleType}`
                const data: any = await makeApiCall(url)
                setData(data.designs.filter((eachDesign: any) => eachDesign.isPersonalizable).map((eachDesign: any) => ({ itemId: eachDesign.designId, image: eachDesign.designImage, name: eachDesign.designName, isPersonalizable: eachDesign.isPersonalizable })))
                setApiStatus(apiStatusConstants.fulfilled)
            } else if (activeAccordion.childAccordion === subAccordionConstants.products) {
                let url = 'https://nestingale.com/v1/api/products?has3DModel=true'
                if (selectedRoomType) url += `&roomType=${selectedRoomType}`
                if (selectedStyleType) url += `&style=${selectedStyleType}`
                const data: any = await makeApiCall(url)
                setData(data.products.filter((eachProduct: any) => eachProduct.model3dUrl))
                dispatch(builderActions.addProductData({ products: data.products.filter((eachProduct: any) => eachProduct.model3dUrl) }))
                setApiStatus(apiStatusConstants.fulfilled)
            } else {
                setApiStatus(apiStatusConstants.rejected)
            }
        }
        if (!searchMode && activeAccordion.childAccordion && (activeAccordion.childAccordion === subAccordionConstants.designs || activeAccordion.childAccordion === subAccordionConstants.products)) {
            fetchData()
        }
    }, [activeAccordion.childAccordion, selectedRoomType, selectedStyleType])
    const renderUi = (eachItem: any) => {
        if (activeAccordion.parentAccordion === accordionTitleConstants.designs) {
            return (
                <Grid item xs={6} key={eachItem.itemId}>
                    <EachDesignCard eachDesign={eachItem} handleMenuCloseDesignDetail={handleMenuCloseDesignDetail} handleSelectedDesignDetailId={handleSelectedDesignDetailId} />
                </Grid>
            )
        }
        if (activeAccordion.parentAccordion === accordionTitleConstants.products) {
            return (
                <Grid item xs={6} key={eachItem.productId}>
                    <EachProductCard eachProduct={eachItem} handleCloseProductDetails={handleCloseProductDetails} handleSelectedProductDetailId={handleSelectedProductDetailId} />
                </Grid>)
        }
        return null;
    }
    function getCurrentView(apiStatus: string) {
        switch (apiStatus) {
            case apiStatusConstants.pending:
                return <Box component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><LoadingSpinner /></Box>
            case apiStatusConstants.fulfilled:
                return <>{data.length > 0 ?
                    <Grid container spacing={2}>
                        {data.map(renderUi)}
                    </Grid> : <Box component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><NoItemsMessage textToShow={`No ${productsMode ? "products" : 'designs'} available`} fontSize="16px" /></Box>}
                </>
            case apiStatusConstants.rejected:
                return <Box component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><NoItemsMessage textToShow={`No ${productsMode ? "products" : 'designs'} available`} fontSize="16px" /></Box>
            default:
                return null
        }
    }
    //root return jsx
    return (
        <>
            <Box component="div" sx={{ height: `${isVisibleSearch ? '180px' : '70px'}`, position: 'relative' }}>
                {(activeAccordion.childAccordion === subAccordionConstants.products) && <SearchIcon onClick={() => {
                    if (isVisibleSearch) {
                        gtmClickTracking({
                            event: 'search_bar_close'
                        })
                    } else {
                        gtmClickTracking({
                            event: 'search_bar_open'
                        })
                    }
                    setIsVisibleSearch(!isVisibleSearch)
                }} sx={{ color: `${isVisibleSearch ? '#FE6526' : '#52575C'}`, fontSize: '25px', cursor: 'pointer', position: 'absolute', top: '0px', left: '-12px' }} />}
                <HighlightOffIcon onClick={() => {
                    handleMoreItemsClosed(true)
                    handleActiveAccordion({ parentAccordion: '', childAccordion: '' })
                }} sx={{ color: '#52575C', fontSize: '25px', cursor: 'pointer', position: 'absolute', top: '0px', right: '5px' }} />
                <Typography sx={{ fontSize: '16px', fontWeight: '700', display: 'flex', justifyContent: 'center' }}>{activeAccordion?.childAccordion}</Typography>
                {/* search */}
                {isVisibleSearch &&
                    <Box component="div" sx={{ position: 'relative', background: 'rgba(253, 244, 237, 0.8)', padding: '10px', width: 'calc(100% + 30px)', marginLeft: '-20px', textAlign: 'center', marginTop: '10px' }}>
                        <input type="text" placeholder="What can we help you find?" style={{ borderRadius: '22px', border: 'none', padding: '5px 5px', width: '100%' }} autoFocus value={query} onChange={(event: any) => { setQuery(event.target.value.trim(' ')) }} onKeyDown={(event: any) => {
                            if (event.key === "Enter" && query.length > 0) {
                                setSearchMode(true)
                                setSearchInput(query)
                                setShowSearchQueryResults(false)
                                setSelectedRoomType('')
                                setSelectedStyleType('')
                            }
                        }} onFocus={() => {
                            if (query.length > 0) {
                                setShowSearchQueryResults(true)
                            }
                        }} />
                        <SearchIcon sx={{ position: 'absolute', right: '20px', bottom: '17px', fontSize: '20px', cursor: 'pointer' }} />
                    </Box>
                }
                {(query.length > 0 && isVisibleSearch && showSearchQueryResults) && (
                    <Box component="div" className="custom_scrollbar"
                        sx={{ position: "absolute", top: '45%', left: '-1%', width: "100%", background: "white", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)", borderRadius: "10px", zIndex: 10, padding: "10px", marginTop: "5px", maxHeight: "200px", overflowY: "auto", }}
                        ref={resultsContainerRef}
                    >
                        {searchSuggestions.length > 0 ? (
                            searchSuggestions.map((result: any, index: number) => (
                                <Box component="div"
                                    key={result.searchTerm}
                                    sx={{
                                        padding: "4px",
                                        cursor: "pointer",
                                        "&:hover": { backgroundColor: "#f5f5f5" },
                                        borderBottom: index === searchSuggestions.length - 1 ? "none" : "1px solid #ddd"
                                    }}
                                    onClick={() => {
                                        setSearchMode(true)
                                        setQuery(result.searchTerm)
                                        setSearchInput(result.searchTerm)
                                        setShowSearchQueryResults(false)
                                        setSelectedRoomType('')
                                        setSelectedStyleType('')
                                        // fetchSearchResult()
                                    }}
                                >
                                    {result.searchTerm}
                                </Box>
                            ))
                        ) : (
                            <Box component="div" sx={{ padding: "8px", color: "#999" }}>No results found</Box>
                        )}
                    </Box>
                )}
                {/* filters */}
                <Box component="div" sx={{ display: 'flex', padding: '20px 10px 10px 0', zIndex: 1 }}>
                    {showFilters && <Box component="div" sx={{ marginRight: 'auto', fontSize: '12px', color: '#0D908E', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {
                        if (activeAccordion?.parentAccordion === accordionTitleConstants.designs) {
                            if (!isVisibleStyles) {
                                gtmClickTracking({ event: 'design_filter_by_style' })
                            }
                        } else {
                            if (!isVisibleStyles) {
                                gtmClickTracking({ event: 'product_filter_by_style' })
                            }
                        }
                        setIsVisibleStyles(!isVisibleStyles)
                    }}>Style(s): {currentSelectedStyleDisplayName}</Box>}
                    {isVisibleStyles &&
                        <Box component="div" sx={{ display: 'flex', flexWrap: 'wrap', padding: '10px', position: 'absolute', top: '40px', boxShadow: '3px 4px 8px 0px rgba(0,0,0,0.25)', width: '180px', background: 'rgba(255, 255, 255, 0.9)', border: 'solid 1px #7F7F7F', borderRadius: '10px', zIndex: 1 }}>
                            <Box component="div" sx={{ marginRight: 'auto', fontSize: '12px', color: '#0D908E', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {
                                setIsVisibleStyles(!isVisibleStyles)
                                setSelectedStyleType('')
                            }}>Clear</Box>
                            <Box component="div" sx={{ marginLeft: 'auto', fontSize: '12px', color: '#0D908E', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setIsVisibleStyles(!isVisibleStyles)}>Close</Box>
                            <Box component="div" sx={{ flexBasis: '100%', height: '10px' }}></Box>
                            {
                                styles.map((eachStyle: any) => {
                                    return <Box key={eachStyle.styleId} onClick={(event: any) => {
                                        event.stopPropagation()
                                        setSelectedStyleType(eachStyle.style);
                                        setIsVisibleStyles(!isVisibleStyles)
                                    }} component="div" sx={{ background: 'none', margin: '0px 5px 5px 0', cursor: 'pointer', border: currentSelectedStyleDisplayName === eachStyle.styleDisplayName ? 'solid 1px #0D908E' : 'solid 1px #7F7F7F', color: currentSelectedStyleDisplayName === eachStyle.styleDisplayName ? '#0D908E' : null, borderRadius: '5px', fontSize: '10px', padding: '8px' }}>{eachStyle.styleDisplayName}</Box>
                                })
                            }
                        </Box>
                    }
                    {showFilters && <Box component="div" sx={{ marginLeft: 'auto', fontSize: '12px', color: '#0D908E', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {
                        if (activeAccordion?.parentAccordion === accordionTitleConstants.designs) {
                            if (!isVisibleRooms) {
                                gtmClickTracking({ event: 'design_filter_by_room' })
                            }
                        } else {
                            if (!isVisibleRooms) {
                                gtmClickTracking({ event: 'product_filter_by_room' })
                            }
                        }
                        setIsVisibleRooms(!isVisibleRooms)
                    }} >Room(s):{currentSelectedRoomDisplayName}</Box>}
                    {isVisibleRooms &&
                        <Box component="div" sx={{ display: 'flex', flexWrap: 'wrap', padding: '10px', position: 'absolute', top: '40px', boxShadow: '3px 4px 8px 0px rgba(0,0,0,0.25)', right: '0px', width: '180px', background: 'rgba(255, 255, 255, 0.9)', border: 'solid 1px #7F7F7F', borderRadius: '10px', zIndex: 1 }}>
                            <Box component="div" sx={{ marginRight: 'auto', fontSize: '12px', color: '#0D908E', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {
                                setIsVisibleRooms(!isVisibleRooms)
                                setSelectedRoomType('');
                                setSelectedStyleType('')
                            }}>Clear</Box>
                            <Box component="div" sx={{ marginLeft: 'auto', fontSize: '12px', color: '#0D908E', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setIsVisibleRooms(!isVisibleRooms)}>Close</Box>
                            <Box component="div" sx={{ flexBasis: '100%', height: '10px' }}></Box>
                            {
                                roomTypes.map((eachRoomType: any) => {
                                    return <Box key={eachRoomType.roomTypeId} onClick={(event: any) => {
                                        event.stopPropagation()
                                        setSelectedRoomType(eachRoomType.roomType);
                                        setSelectedStyleType('')
                                        setIsVisibleRooms(!isVisibleRooms)
                                    }} component="div" sx={{ background: 'none', margin: '0px 5px 5px 0', cursor: 'pointer', border: currentSelectedRoomDisplayName === eachRoomType.roomTypeDisplayName ? 'solid 1px #0D908E' : 'solid 1px #7F7F7F', color: currentSelectedRoomDisplayName === eachRoomType.roomTypeDisplayName ? '#0D908E' : null, borderRadius: '5px', fontSize: '10px', padding: '8px' }}>{eachRoomType.roomTypeDisplayName}</Box>
                                })
                            }
                        </Box>
                    }
                </Box>
            </Box>
            <Box component='div' className="custom_scrollbar" sx={{ overflowY: 'auto', height: `${isVisibleSearch ? 'calc(100% - 180px)' : 'calc(100% - 70px)'}` }}>
                {getCurrentView(apiStatus)}
            </Box>
        </>
    );
}
export default MoreItems